module.exports = __webpack_public_path__ + "static/img/img14.537af45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img14.png
// module id = Mgea
// module chunks = 1